<div class="contextmenu" [ngStyle]="{ 'left.px': positionX, 'top.px': positionY }" data-cy="note-boilerplates-context-menu">
  <div matTooltip="Disabled until action has completed" matTooltipDisabled="{{ !actionsDisabled }}" data-cy="note-boilerplates-context-add-container">
    <button mat-button color="primary"
            [disabled]="actionsDisabled" class="context-button" (click)="emitAddNew()" data-cy="note-boilerplates-context-add-button">
      Add new
    </button>
  </div>
  <div matTooltip="Disabled until action has completed" *ngIf="!clickedEmptySpace" matTooltipDisabled="{{ !actionsDisabled }}" data-cy="note-boilerplates-context-edit-container">
    <button mat-button color="primary"
            [disabled]="actionsDisabled" class="context-button" (click)="emitEdit()" data-cy="note-boilerplates-context-edit-button">
      Edit
    </button>
  </div>
  <div matTooltip="Disabled until saving is completed" *ngIf="!clickedEmptySpace" matTooltipDisabled="{{ !actionsDisabled }}" data-cy="note-boilerplates-context-delete-container">
    <button mat-button color="primary"
            (click)="emitDelete()"
            [disabled]="actionsDisabled" class="context-button" data-cy="note-boilerplates-context-delete-button">
      Delete
    </button>
  </div>
</div>
